<template lang="pug">
    div.cf__login
        router-link.logo(to="/")
            div.section ADMIN
            img.image(src="@/assets/logo.png")

        form.form(name="formRegister")
            div.error(v-html="error")
            label.form__group
                div.label
                    include ../../snippets/user.pug
                    span.hidden Эл. почта
                input#reg__name.form__input(type='text', name='email', v-model="name" placeholder='Имя Фамилия', required='')

            label.form__group
                div.label
                    include ../../snippets/user.pug
                    span.hidden Эл. почта
                input#reg__email.form__input(type='text', name='email', v-model="email" placeholder='Эл. почта', required='')

            label.form__group.mb30
                div.label
                    include ../../snippets/lock.pug
                    span.hidden Username
                input#reg__password.form__input(type='text', name='password', v-model="password", placeholder='Пароль', required='')

            button.btn-gray.btn_large.border.btnSendLogin(@click="register") Регистрация
</template>

<script>
  import Auth from '@/services/Auth'
  export default {
      name: "register",
      data() {
          return {
              name: '',
              email: '',
              password: '',
              error: null
          }
      },
      methods: {
          async register() {
              try {
                  const res = await Auth.register({
                      name: this.name,
                      email: this.email,
                      password: this.password
                  });
                  this.$store.dispatch('setToken', res.data.token);
                  this.$store.dispatch('setUser', res.data.user);
              } catch (error) {
                  this.error = error.response.data.error
              }
          }
      }
  }
</script>

<!--<style lang="scss">-->
  <!--@import '@/admin/scss/app.scss';-->

  <!--body {-->
    <!--background-color: #2c3338;-->
  <!--}-->
<!--</style>-->
